import PropTypes from 'prop-types'
import React, { useContext } from 'react'

import FeaturesPlate from 'components/_special/FeaturesPlate'
import FeaturesPlateNew from 'components/_special/FeaturesPlateNew'
import ButtonRounded from 'components/ButtonRounded'
import { RU } from 'constants/countries'
import { LocalizationContext } from 'contexts/Localization'
import { Col } from 'styles/components/layout'

import { ButtonBlock, BoxBaseStyled, RowIndentedStyled } from './styles'

/*
 * We are going to use this component on About DNA page and on About WGS page.
 */
const WillLearnDna = ({
  data,
  mobile,
  results,
  isNoWrapContent,
  isTextWhite,
  bgClassName,
}) => {
  const { dict, locale } = useContext(LocalizationContext)

  return (
    <BoxBaseStyled isRu={locale === RU}>
      <RowIndentedStyled
        indent={{ xs: 0, md: 20 }}
        isRu={locale === RU}
        isBlackBg={isTextWhite}
      >
        <Col width={{ xs: 1 }}>
          {locale === RU ? (
            <FeaturesPlateNew
              {...{ data, mobile }}
              isNoWrapContent={isNoWrapContent}
              isTextWhite={isTextWhite}
            />
          ) : (
            <FeaturesPlate
              {...{ data, mobile }}
              isNoWrapContent={isNoWrapContent}
              isTextWhite={isTextWhite}
            />
          )}
        </Col>
      </RowIndentedStyled>

      <ButtonBlock>
        <ButtonRounded
          as="Link"
          to={results.link(locale)}
          asPath={results.as(locale)}
          bgClassName={bgClassName}
        >
          {dict.buttons.learn_more}
        </ButtonRounded>
      </ButtonBlock>
    </BoxBaseStyled>
  )
}

WillLearnDna.propTypes = {
  data: PropTypes.object.isRequired,
  mobile: PropTypes.bool.isRequired,
  results: PropTypes.object.isRequired,
  isNoWrapContent: PropTypes.bool,
  isTextWhite: PropTypes.bool,
  bgClassName: PropTypes.string,
}

WillLearnDna.defaultProps = {
  isNoWrapContent: true,
  isTextWhite: false,
}

export default WillLearnDna
